<script>
	export let fill = "fill-company-primary ";
</script>

<div class={$$props.class + " pointer-events-none"}>
	<svg
		class="opacity-5 {fill}"
		width="387"
		height="530"
		viewBox="0 0 387 530"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_1_608)">
			<g filter="url(#filter0_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M368.466 18.5549C372.562 18.5549 375.88 15.2336 375.88 11.1329C375.88 4.98384 380.858 -2.6848e-07 387 0L387 3.71098C382.904 3.71098 379.586 7.0323 379.586 11.1329C379.586 17.282 374.608 22.2659 368.466 22.2659C364.37 22.2659 361.053 25.5872 361.053 29.6878C361.053 35.8369 356.074 40.8208 349.932 40.8208C345.836 40.8208 342.519 44.1421 342.519 48.2427L338.812 48.2427C338.812 42.0936 343.79 37.1098 349.932 37.1098C354.028 37.1098 357.346 33.7885 357.346 29.6878C357.346 23.5387 362.324 18.5549 368.466 18.5549ZM372.08 65.8031L356.352 81.5488L353.732 78.9251L369.46 63.1794L372.08 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter1_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M368.466 114.931C372.562 114.931 375.88 111.61 375.88 107.509C375.88 101.36 380.858 96.376 387 96.376L387 100.087C382.904 100.087 379.586 103.408 379.586 107.509C379.586 113.658 374.608 118.642 368.466 118.642C364.37 118.642 361.053 121.963 361.053 126.064C361.053 132.213 356.074 137.197 349.932 137.197C345.836 137.197 342.519 140.518 342.519 144.619L338.812 144.619C338.812 138.47 343.79 133.486 349.932 133.486C354.028 133.486 357.346 130.164 357.346 126.064C357.346 119.915 362.324 114.931 368.466 114.931ZM372.08 162.179L356.352 177.925L353.732 175.301L369.46 159.555L372.08 162.179Z"
				></path>
			</g>
			<g filter="url(#filter2_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M368.466 211.306C372.562 211.306 375.88 207.985 375.88 203.884C375.88 197.735 380.858 192.751 387 192.751L387 196.462C382.904 196.462 379.586 199.784 379.586 203.884C379.586 210.033 374.608 215.017 368.466 215.017C364.37 215.017 361.053 218.339 361.053 222.439C361.053 228.588 356.074 233.572 349.932 233.572C345.836 233.572 342.519 236.894 342.519 240.994L338.812 240.994C338.812 234.845 343.79 229.861 349.932 229.861C354.028 229.861 357.346 226.54 357.346 222.439C357.346 216.29 362.324 211.306 368.466 211.306ZM372.08 258.555L356.352 274.3L353.732 271.677L369.46 255.931L372.08 258.555Z"
				></path>
			</g>
			<g filter="url(#filter3_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M368.466 307.682C372.562 307.682 375.88 304.361 375.88 300.26C375.88 294.111 380.858 289.127 387 289.127L387 292.838C382.904 292.838 379.586 296.16 379.586 300.26C379.586 306.409 374.608 311.393 368.466 311.393C364.37 311.393 361.053 314.715 361.053 318.815C361.053 324.964 356.074 329.948 349.932 329.948C345.836 329.948 342.519 333.27 342.519 337.37L338.812 337.37C338.812 331.221 343.79 326.237 349.932 326.237C354.028 326.237 357.346 322.916 357.346 318.815C357.346 312.666 362.324 307.682 368.466 307.682ZM372.08 354.931L356.352 370.676L353.732 368.053L369.46 352.307L372.08 354.931Z"
				></path>
			</g>
			<g filter="url(#filter4_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M368.466 404.058C372.562 404.058 375.88 400.737 375.88 396.636C375.88 390.487 380.858 385.503 387 385.503L387 389.214C382.904 389.214 379.586 392.536 379.586 396.636C379.586 402.785 374.608 407.769 368.466 407.769C364.37 407.769 361.053 411.091 361.053 415.191C361.053 421.34 356.074 426.324 349.932 426.324C345.836 426.324 342.519 429.646 342.519 433.746L338.812 433.746C338.812 427.597 343.79 422.613 349.932 422.613C354.028 422.613 357.346 419.292 357.346 415.191C357.346 409.042 362.324 404.058 368.466 404.058ZM372.08 451.306L356.352 467.052L353.732 464.429L369.46 448.683L372.08 451.306Z"
				></path>
			</g>
			<g filter="url(#filter5_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M368.466 500.434C372.562 500.434 375.88 497.113 375.88 493.012C375.88 486.863 380.858 481.879 387 481.879L387 485.59C382.904 485.59 379.586 488.911 379.586 493.012C379.586 499.161 374.608 504.145 368.466 504.145C364.37 504.145 361.053 507.466 361.053 511.567C361.053 517.716 356.074 522.7 349.932 522.7C345.836 522.7 342.519 526.021 342.519 530.122L338.812 530.122C338.812 523.973 343.79 518.989 349.932 518.989C354.028 518.989 357.346 515.668 357.346 511.567C357.346 505.418 362.324 500.434 368.466 500.434ZM372.08 547.682L356.352 563.428L353.732 560.804L369.46 545.059L372.08 547.682Z"
				></path>
			</g>
			<g filter="url(#filter6_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M312.865 18.5549C316.961 18.5549 320.278 15.2336 320.278 11.1329C320.278 4.98384 325.256 -2.6848e-07 331.399 0L331.399 3.71098C327.303 3.71098 323.985 7.0323 323.985 11.1329C323.985 17.282 319.007 22.2659 312.865 22.2659C308.769 22.2659 305.451 25.5872 305.451 29.6878C305.451 35.8369 300.473 40.8208 294.331 40.8208C290.235 40.8208 286.917 44.1421 286.917 48.2427L283.211 48.2427C283.211 42.0936 288.189 37.1098 294.331 37.1098C298.427 37.1098 301.744 33.7885 301.744 29.6878C301.744 23.5387 306.723 18.5549 312.865 18.5549ZM316.479 65.8031L300.751 81.5488L298.13 78.9251L313.858 63.1794L316.479 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter7_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M312.865 114.931C316.961 114.931 320.278 111.61 320.278 107.509C320.278 101.36 325.256 96.376 331.399 96.376L331.399 100.087C327.303 100.087 323.985 103.408 323.985 107.509C323.985 113.658 319.007 118.642 312.865 118.642C308.769 118.642 305.451 121.963 305.451 126.064C305.451 132.213 300.473 137.197 294.331 137.197C290.235 137.197 286.917 140.518 286.917 144.619L283.211 144.619C283.211 138.47 288.189 133.486 294.331 133.486C298.427 133.486 301.744 130.164 301.744 126.064C301.744 119.915 306.723 114.931 312.865 114.931ZM316.479 162.179L300.751 177.925L298.13 175.301L313.858 159.555L316.479 162.179Z"
				></path>
			</g>
			<g filter="url(#filter8_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M312.865 211.306C316.961 211.306 320.278 207.985 320.278 203.884C320.278 197.735 325.256 192.751 331.399 192.751L331.399 196.462C327.303 196.462 323.985 199.784 323.985 203.884C323.985 210.033 319.007 215.017 312.865 215.017C308.769 215.017 305.451 218.339 305.451 222.439C305.451 228.588 300.473 233.572 294.331 233.572C290.235 233.572 286.917 236.894 286.917 240.994L283.211 240.994C283.211 234.845 288.189 229.861 294.331 229.861C298.427 229.861 301.744 226.54 301.744 222.439C301.744 216.29 306.723 211.306 312.865 211.306ZM316.479 258.555L300.751 274.3L298.13 271.677L313.858 255.931L316.479 258.555Z"
				></path>
			</g>
			<g filter="url(#filter9_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M312.865 307.682C316.961 307.682 320.278 304.361 320.278 300.26C320.278 294.111 325.256 289.127 331.399 289.127L331.399 292.838C327.303 292.838 323.985 296.16 323.985 300.26C323.985 306.409 319.007 311.393 312.865 311.393C308.769 311.393 305.451 314.715 305.451 318.815C305.451 324.964 300.473 329.948 294.331 329.948C290.235 329.948 286.917 333.27 286.917 337.37L283.211 337.37C283.211 331.221 288.189 326.237 294.331 326.237C298.427 326.237 301.744 322.916 301.744 318.815C301.744 312.666 306.723 307.682 312.865 307.682ZM316.479 354.931L300.751 370.676L298.13 368.053L313.858 352.307L316.479 354.931Z"
				></path>
			</g>
			<g filter="url(#filter10_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M312.865 404.058C316.961 404.058 320.278 400.737 320.278 396.636C320.278 390.487 325.256 385.503 331.399 385.503L331.399 389.214C327.303 389.214 323.985 392.535 323.985 396.636C323.985 402.785 319.007 407.769 312.865 407.769C308.769 407.769 305.451 411.09 305.451 415.191C305.451 421.34 300.473 426.324 294.331 426.324C290.235 426.324 286.917 429.645 286.917 433.746L283.211 433.746C283.211 427.597 288.189 422.613 294.331 422.613C298.427 422.613 301.744 419.292 301.744 415.191C301.744 409.042 306.723 404.058 312.865 404.058ZM316.479 451.306L300.751 467.052L298.13 464.428L313.858 448.683L316.479 451.306Z"
				></path>
			</g>
			<g filter="url(#filter11_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M312.865 500.434C316.961 500.434 320.278 497.113 320.278 493.012C320.278 486.863 325.256 481.879 331.399 481.879L331.399 485.59C327.303 485.59 323.985 488.911 323.985 493.012C323.985 499.161 319.007 504.145 312.865 504.145C308.769 504.145 305.451 507.466 305.451 511.567C305.451 517.716 300.473 522.7 294.331 522.7C290.235 522.7 286.917 526.021 286.917 530.122L283.211 530.122C283.211 523.973 288.189 518.989 294.331 518.989C298.427 518.989 301.744 515.668 301.744 511.567C301.744 505.418 306.723 500.434 312.865 500.434ZM316.479 547.682L300.751 563.428L298.13 560.804L313.858 545.059L316.479 547.682Z"
				></path>
			</g>
			<g filter="url(#filter12_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M257.263 18.5549C261.359 18.5549 264.677 15.2336 264.677 11.1329C264.677 4.98384 269.655 -2.6848e-07 275.797 0L275.797 3.71098C271.701 3.71098 268.384 7.0323 268.384 11.1329C268.384 17.282 263.405 22.2659 257.263 22.2659C253.167 22.2659 249.85 25.5872 249.85 29.6878C249.85 35.8369 244.872 40.8208 238.73 40.8208C234.634 40.8208 231.316 44.1421 231.316 48.2427L227.609 48.2427C227.609 42.0936 232.587 37.1098 238.73 37.1098C242.825 37.1098 246.143 33.7885 246.143 29.6878C246.143 23.5387 251.121 18.5549 257.263 18.5549ZM260.877 65.8031L245.15 81.5488L242.529 78.9251L258.257 63.1794L260.877 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter13_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M257.263 114.931C261.359 114.931 264.677 111.61 264.677 107.509C264.677 101.36 269.655 96.376 275.797 96.376L275.797 100.087C271.701 100.087 268.384 103.408 268.384 107.509C268.384 113.658 263.405 118.642 257.263 118.642C253.167 118.642 249.85 121.963 249.85 126.064C249.85 132.213 244.872 137.197 238.73 137.197C234.634 137.197 231.316 140.518 231.316 144.619L227.609 144.619C227.609 138.47 232.587 133.486 238.73 133.486C242.825 133.486 246.143 130.164 246.143 126.064C246.143 119.915 251.121 114.931 257.263 114.931ZM260.877 162.179L245.15 177.925L242.529 175.301L258.257 159.555L260.877 162.179Z"
				></path>
			</g>
			<g filter="url(#filter14_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M257.263 211.306C261.359 211.306 264.677 207.985 264.677 203.884C264.677 197.735 269.655 192.751 275.797 192.751L275.797 196.462C271.701 196.462 268.384 199.784 268.384 203.884C268.384 210.033 263.405 215.017 257.263 215.017C253.167 215.017 249.85 218.339 249.85 222.439C249.85 228.588 244.872 233.572 238.73 233.572C234.634 233.572 231.316 236.894 231.316 240.994L227.609 240.994C227.609 234.845 232.587 229.861 238.73 229.861C242.825 229.861 246.143 226.54 246.143 222.439C246.143 216.29 251.121 211.306 257.263 211.306ZM260.877 258.555L245.15 274.3L242.529 271.677L258.257 255.931L260.877 258.555Z"
				></path>
			</g>
			<g filter="url(#filter15_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M257.263 307.682C261.359 307.682 264.677 304.361 264.677 300.26C264.677 294.111 269.655 289.127 275.797 289.127L275.797 292.838C271.701 292.838 268.384 296.16 268.384 300.26C268.384 306.409 263.405 311.393 257.263 311.393C253.167 311.393 249.85 314.715 249.85 318.815C249.85 324.964 244.872 329.948 238.73 329.948C234.634 329.948 231.316 333.27 231.316 337.37L227.609 337.37C227.609 331.221 232.587 326.237 238.73 326.237C242.825 326.237 246.143 322.916 246.143 318.815C246.143 312.666 251.121 307.682 257.263 307.682ZM260.877 354.931L245.15 370.676L242.529 368.053L258.257 352.307L260.877 354.931Z"
				></path>
			</g>
			<g filter="url(#filter16_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M257.263 404.058C261.359 404.058 264.677 400.737 264.677 396.636C264.677 390.487 269.655 385.503 275.797 385.503L275.797 389.214C271.701 389.214 268.384 392.535 268.384 396.636C268.384 402.785 263.405 407.769 257.263 407.769C253.167 407.769 249.85 411.09 249.85 415.191C249.85 421.34 244.872 426.324 238.729 426.324C234.634 426.324 231.316 429.645 231.316 433.746L227.609 433.746C227.609 427.597 232.587 422.613 238.729 422.613C242.825 422.613 246.143 419.292 246.143 415.191C246.143 409.042 251.121 404.058 257.263 404.058ZM260.877 451.306L245.15 467.052L242.529 464.428L258.257 448.683L260.877 451.306Z"
				></path>
			</g>
			<g filter="url(#filter17_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M257.263 500.434C261.359 500.434 264.677 497.113 264.677 493.012C264.677 486.863 269.655 481.879 275.797 481.879L275.797 485.59C271.701 485.59 268.384 488.911 268.384 493.012C268.384 499.161 263.405 504.145 257.263 504.145C253.167 504.145 249.85 507.466 249.85 511.567C249.85 517.716 244.872 522.7 238.729 522.7C234.634 522.7 231.316 526.021 231.316 530.122L227.609 530.122C227.609 523.973 232.587 518.989 238.729 518.989C242.825 518.989 246.143 515.668 246.143 511.567C246.143 505.418 251.121 500.434 257.263 500.434ZM260.877 547.682L245.15 563.428L242.529 560.804L258.257 545.059L260.877 547.682Z"
				></path>
			</g>
			<g filter="url(#filter18_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M201.662 18.5549C205.758 18.5549 209.075 15.2336 209.075 11.1329C209.075 4.98384 214.054 -2.6848e-07 220.196 0L220.196 3.71098C216.1 3.71098 212.782 7.0323 212.782 11.1329C212.782 17.282 207.804 22.2659 201.662 22.2659C197.566 22.2659 194.248 25.5872 194.248 29.6878C194.248 35.8369 189.27 40.8208 183.128 40.8208C179.032 40.8208 175.715 44.1421 175.715 48.2427L172.008 48.2427C172.008 42.0936 176.986 37.1098 183.128 37.1098C187.224 37.1098 190.542 33.7885 190.542 29.6878C190.542 23.5387 195.52 18.5549 201.662 18.5549ZM205.276 65.8031L189.548 81.5488L186.927 78.9251L202.655 63.1794L205.276 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter19_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M201.662 114.931C205.758 114.931 209.075 111.61 209.075 107.509C209.075 101.36 214.054 96.376 220.196 96.376L220.196 100.087C216.1 100.087 212.782 103.408 212.782 107.509C212.782 113.658 207.804 118.642 201.662 118.642C197.566 118.642 194.248 121.963 194.248 126.064C194.248 132.213 189.27 137.197 183.128 137.197C179.032 137.197 175.715 140.518 175.715 144.619L172.008 144.619C172.008 138.47 176.986 133.486 183.128 133.486C187.224 133.486 190.542 130.164 190.542 126.064C190.542 119.915 195.52 114.931 201.662 114.931ZM205.276 162.179L189.548 177.925L186.927 175.301L202.655 159.555L205.276 162.179Z"
				></path>
			</g>
			<g filter="url(#filter20_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M201.662 211.306C205.758 211.306 209.075 207.985 209.075 203.884C209.075 197.735 214.054 192.751 220.196 192.751L220.196 196.462C216.1 196.462 212.782 199.784 212.782 203.884C212.782 210.033 207.804 215.017 201.662 215.017C197.566 215.017 194.248 218.339 194.248 222.439C194.248 228.588 189.27 233.572 183.128 233.572C179.032 233.572 175.715 236.894 175.715 240.994L172.008 240.994C172.008 234.845 176.986 229.861 183.128 229.861C187.224 229.861 190.542 226.54 190.542 222.439C190.542 216.29 195.52 211.306 201.662 211.306ZM205.276 258.555L189.548 274.3L186.927 271.677L202.655 255.931L205.276 258.555Z"
				></path>
			</g>
			<g filter="url(#filter21_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M201.662 307.682C205.758 307.682 209.075 304.361 209.075 300.26C209.075 294.111 214.054 289.127 220.196 289.127L220.196 292.838C216.1 292.838 212.782 296.16 212.782 300.26C212.782 306.409 207.804 311.393 201.662 311.393C197.566 311.393 194.248 314.715 194.248 318.815C194.248 324.964 189.27 329.948 183.128 329.948C179.032 329.948 175.715 333.27 175.715 337.37L172.008 337.37C172.008 331.221 176.986 326.237 183.128 326.237C187.224 326.237 190.542 322.916 190.542 318.815C190.542 312.666 195.52 307.682 201.662 307.682ZM205.276 354.931L189.548 370.676L186.927 368.053L202.655 352.307L205.276 354.931Z"
				></path>
			</g>
			<g filter="url(#filter22_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M201.662 404.058C205.758 404.058 209.075 400.737 209.075 396.636C209.075 390.487 214.054 385.503 220.196 385.503L220.196 389.214C216.1 389.214 212.782 392.535 212.782 396.636C212.782 402.785 207.804 407.769 201.662 407.769C197.566 407.769 194.248 411.09 194.248 415.191C194.248 421.34 189.27 426.324 183.128 426.324C179.032 426.324 175.715 429.645 175.715 433.746L172.008 433.746C172.008 427.597 176.986 422.613 183.128 422.613C187.224 422.613 190.542 419.292 190.542 415.191C190.542 409.042 195.52 404.058 201.662 404.058ZM205.276 451.306L189.548 467.052L186.927 464.428L202.655 448.683L205.276 451.306Z"
				></path>
			</g>
			<g filter="url(#filter23_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M201.662 500.434C205.758 500.434 209.075 497.113 209.075 493.012C209.075 486.863 214.054 481.879 220.196 481.879L220.196 485.59C216.1 485.59 212.782 488.911 212.782 493.012C212.782 499.161 207.804 504.145 201.662 504.145C197.566 504.145 194.248 507.466 194.248 511.567C194.248 517.716 189.27 522.7 183.128 522.7C179.032 522.7 175.715 526.021 175.715 530.122L172.008 530.122C172.008 523.973 176.986 518.989 183.128 518.989C187.224 518.989 190.542 515.668 190.542 511.567C190.542 505.418 195.52 500.434 201.662 500.434ZM205.276 547.682L189.548 563.428L186.927 560.804L202.655 545.059L205.276 547.682Z"
				></path>
			</g>
			<g filter="url(#filter24_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M146.06 18.5549C150.156 18.5549 153.474 15.2336 153.474 11.1329C153.474 4.98384 158.452 -2.6848e-07 164.594 0L164.594 3.71098C160.498 3.71098 157.181 7.0323 157.181 11.1329C157.181 17.282 152.203 22.2659 146.06 22.2659C141.964 22.2659 138.647 25.5872 138.647 29.6878C138.647 35.8369 133.669 40.8208 127.527 40.8208C123.431 40.8208 120.113 44.1421 120.113 48.2427L116.406 48.2427C116.406 42.0936 121.385 37.1098 127.527 37.1098C131.623 37.1098 134.94 33.7885 134.94 29.6878C134.94 23.5387 139.918 18.5549 146.06 18.5549ZM149.675 65.8031L133.947 81.5488L131.326 78.9251L147.054 63.1794L149.675 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter25_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M146.06 114.931C150.156 114.931 153.474 111.61 153.474 107.509C153.474 101.36 158.452 96.376 164.594 96.376L164.594 100.087C160.498 100.087 157.181 103.408 157.181 107.509C157.181 113.658 152.203 118.642 146.06 118.642C141.964 118.642 138.647 121.963 138.647 126.064C138.647 132.213 133.669 137.197 127.527 137.197C123.431 137.197 120.113 140.518 120.113 144.619L116.406 144.619C116.406 138.47 121.385 133.486 127.527 133.486C131.623 133.486 134.94 130.164 134.94 126.064C134.94 119.915 139.918 114.931 146.06 114.931ZM149.675 162.179L133.947 177.925L131.326 175.301L147.054 159.555L149.675 162.179Z"
				></path>
			</g>
			<g filter="url(#filter26_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M146.06 211.306C150.156 211.306 153.474 207.985 153.474 203.884C153.474 197.735 158.452 192.751 164.594 192.751L164.594 196.462C160.498 196.462 157.181 199.784 157.181 203.884C157.181 210.033 152.203 215.017 146.06 215.017C141.964 215.017 138.647 218.339 138.647 222.439C138.647 228.588 133.669 233.572 127.527 233.572C123.431 233.572 120.113 236.894 120.113 240.994L116.406 240.994C116.406 234.845 121.385 229.861 127.527 229.861C131.623 229.861 134.94 226.54 134.94 222.439C134.94 216.29 139.918 211.306 146.06 211.306ZM149.675 258.555L133.947 274.3L131.326 271.677L147.054 255.931L149.675 258.555Z"
				></path>
			</g>
			<g filter="url(#filter27_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M146.06 307.682C150.156 307.682 153.474 304.361 153.474 300.26C153.474 294.111 158.452 289.127 164.594 289.127L164.594 292.838C160.498 292.838 157.181 296.16 157.181 300.26C157.181 306.409 152.203 311.393 146.06 311.393C141.964 311.393 138.647 314.715 138.647 318.815C138.647 324.964 133.669 329.948 127.527 329.948C123.431 329.948 120.113 333.27 120.113 337.37L116.406 337.37C116.406 331.221 121.385 326.237 127.527 326.237C131.623 326.237 134.94 322.916 134.94 318.815C134.94 312.666 139.918 307.682 146.06 307.682ZM149.675 354.931L133.947 370.676L131.326 368.053L147.054 352.307L149.675 354.931Z"
				></path>
			</g>
			<g filter="url(#filter28_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M146.06 404.058C150.156 404.058 153.474 400.737 153.474 396.636C153.474 390.487 158.452 385.503 164.594 385.503L164.594 389.214C160.498 389.214 157.181 392.535 157.181 396.636C157.181 402.785 152.203 407.769 146.06 407.769C141.964 407.769 138.647 411.09 138.647 415.191C138.647 421.34 133.669 426.324 127.527 426.324C123.431 426.324 120.113 429.645 120.113 433.746L116.406 433.746C116.406 427.597 121.385 422.613 127.527 422.613C131.623 422.613 134.94 419.292 134.94 415.191C134.94 409.042 139.918 404.058 146.06 404.058ZM149.675 451.306L133.947 467.052L131.326 464.428L147.054 448.683L149.675 451.306Z"
				></path>
			</g>
			<g filter="url(#filter29_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M146.06 500.434C150.156 500.434 153.474 497.113 153.474 493.012C153.474 486.863 158.452 481.879 164.594 481.879L164.594 485.59C160.498 485.59 157.181 488.911 157.181 493.012C157.181 499.161 152.203 504.145 146.06 504.145C141.964 504.145 138.647 507.466 138.647 511.567C138.647 517.716 133.669 522.7 127.527 522.7C123.431 522.7 120.113 526.021 120.113 530.122L116.406 530.122C116.406 523.973 121.385 518.989 127.527 518.989C131.623 518.989 134.94 515.668 134.94 511.567C134.94 505.418 139.918 500.434 146.06 500.434ZM149.675 547.682L133.947 563.428L131.326 560.804L147.054 545.059L149.675 547.682Z"
				></path>
			</g>
			<g filter="url(#filter30_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M90.459 18.5549C94.555 18.5549 97.8725 15.2336 97.8725 11.1329C97.8725 4.98384 102.851 -2.6848e-07 108.993 0L108.993 3.71098C104.897 3.71098 101.579 7.0323 101.579 11.1329C101.579 17.282 96.6011 22.2659 90.459 22.2659C86.363 22.2659 83.0455 25.5872 83.0455 29.6878C83.0455 35.8369 78.0673 40.8208 71.9252 40.8208C67.8292 40.8208 64.5117 44.1421 64.5117 48.2427L60.8049 48.2427C60.8049 42.0936 65.7831 37.1098 71.9252 37.1098C76.0212 37.1098 79.3387 33.7885 79.3387 29.6878C79.3387 23.5387 84.3169 18.5549 90.459 18.5549ZM94.0731 65.8031L78.3453 81.5488L75.7246 78.9251L91.4524 63.1794L94.0731 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter31_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M90.459 114.931C94.555 114.931 97.8725 111.61 97.8725 107.509C97.8725 101.36 102.851 96.376 108.993 96.376L108.993 100.087C104.897 100.087 101.579 103.408 101.579 107.509C101.579 113.658 96.6011 118.642 90.459 118.642C86.363 118.642 83.0455 121.963 83.0455 126.064C83.0455 132.213 78.0673 137.197 71.9252 137.197C67.8292 137.197 64.5117 140.518 64.5117 144.619L60.8049 144.619C60.8049 138.47 65.7831 133.486 71.9252 133.486C76.0212 133.486 79.3387 130.164 79.3387 126.064C79.3387 119.915 84.3169 114.931 90.459 114.931ZM94.0731 162.179L78.3453 177.925L75.7246 175.301L91.4524 159.555L94.0731 162.179Z"
				></path>
			</g>
			<g filter="url(#filter32_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M90.459 211.306C94.555 211.306 97.8725 207.985 97.8725 203.884C97.8725 197.735 102.851 192.751 108.993 192.751L108.993 196.462C104.897 196.462 101.579 199.784 101.579 203.884C101.579 210.033 96.6011 215.017 90.459 215.017C86.363 215.017 83.0455 218.339 83.0455 222.439C83.0455 228.588 78.0673 233.572 71.9252 233.572C67.8292 233.572 64.5117 236.894 64.5117 240.994L60.8049 240.994C60.8049 234.845 65.7831 229.861 71.9252 229.861C76.0212 229.861 79.3387 226.54 79.3387 222.439C79.3387 216.29 84.3169 211.306 90.459 211.306ZM94.0731 258.555L78.3453 274.3L75.7246 271.677L91.4524 255.931L94.0731 258.555Z"
				></path>
			</g>
			<g filter="url(#filter33_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M90.459 307.682C94.555 307.682 97.8725 304.361 97.8725 300.26C97.8725 294.111 102.851 289.127 108.993 289.127L108.993 292.838C104.897 292.838 101.579 296.16 101.579 300.26C101.579 306.409 96.6011 311.393 90.459 311.393C86.363 311.393 83.0455 314.715 83.0455 318.815C83.0455 324.964 78.0673 329.948 71.9252 329.948C67.8292 329.948 64.5117 333.27 64.5117 337.37L60.8049 337.37C60.8049 331.221 65.7831 326.237 71.9252 326.237C76.0212 326.237 79.3387 322.916 79.3387 318.815C79.3387 312.666 84.3169 307.682 90.459 307.682ZM94.0731 354.931L78.3453 370.676L75.7246 368.053L91.4524 352.307L94.0731 354.931Z"
				></path>
			</g>
			<g filter="url(#filter34_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M90.459 404.058C94.555 404.058 97.8725 400.737 97.8725 396.636C97.8725 390.487 102.851 385.503 108.993 385.503L108.993 389.214C104.897 389.214 101.579 392.535 101.579 396.636C101.579 402.785 96.6011 407.769 90.459 407.769C86.363 407.769 83.0455 411.09 83.0455 415.191C83.0455 421.34 78.0673 426.324 71.9252 426.324C67.8292 426.324 64.5117 429.645 64.5117 433.746L60.8049 433.746C60.8049 427.597 65.7831 422.613 71.9252 422.613C76.0212 422.613 79.3387 419.292 79.3387 415.191C79.3387 409.042 84.3169 404.058 90.459 404.058ZM94.0731 451.306L78.3453 467.052L75.7246 464.428L91.4524 448.683L94.0731 451.306Z"
				></path>
			</g>
			<g filter="url(#filter35_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M90.459 500.434C94.555 500.434 97.8725 497.113 97.8725 493.012C97.8725 486.863 102.851 481.879 108.993 481.879L108.993 485.59C104.897 485.59 101.579 488.911 101.579 493.012C101.579 499.161 96.6011 504.145 90.459 504.145C86.363 504.145 83.0455 507.466 83.0455 511.567C83.0455 517.716 78.0673 522.7 71.9252 522.7C67.8292 522.7 64.5117 526.021 64.5117 530.122L60.8049 530.122C60.8049 523.973 65.7831 518.989 71.9252 518.989C76.0212 518.989 79.3387 515.668 79.3387 511.567C79.3387 505.418 84.3169 500.434 90.459 500.434ZM94.0731 547.682L78.3453 563.428L75.7246 560.804L91.4524 545.059L94.0731 547.682Z"
				></path>
			</g>
			<g filter="url(#filter36_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.8576 18.5549C38.9535 18.5549 42.2711 15.2336 42.2711 11.1329C42.2711 4.98384 47.2493 -2.6848e-07 53.3914 0L53.3914 3.71098C49.2954 3.71098 45.9779 7.0323 45.9779 11.1329C45.9779 17.282 40.9997 22.2659 34.8576 22.2659C30.7616 22.2659 27.4441 25.5872 27.4441 29.6878C27.4441 35.8369 22.4659 40.8208 16.3238 40.8208C12.2278 40.8208 8.91024 44.1421 8.91024 48.2427L5.20348 48.2427C5.20348 42.0936 10.1817 37.1098 16.3238 37.1098C20.4197 37.1098 23.7373 33.7885 23.7373 29.6878C23.7373 23.5387 28.7155 18.5549 34.8576 18.5549ZM38.4717 65.8031L22.7439 81.5488L20.1232 78.9251L35.851 63.1794L38.4717 65.8031Z"
				></path>
			</g>
			<g filter="url(#filter37_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.8576 114.931C38.9535 114.931 42.2711 111.61 42.2711 107.509C42.2711 101.36 47.2493 96.376 53.3914 96.376L53.3914 100.087C49.2954 100.087 45.9779 103.408 45.9779 107.509C45.9779 113.658 40.9997 118.642 34.8576 118.642C30.7616 118.642 27.444 121.963 27.444 126.064C27.444 132.213 22.4659 137.197 16.3238 137.197C12.2278 137.197 8.91024 140.518 8.91024 144.619L5.20347 144.619C5.20347 138.47 10.1817 133.486 16.3238 133.486C20.4197 133.486 23.7373 130.164 23.7373 126.064C23.7373 119.915 28.7155 114.931 34.8576 114.931ZM38.4717 162.179L22.7439 177.925L20.1232 175.301L35.851 159.555L38.4717 162.179Z"
				></path>
			</g>
			<g filter="url(#filter38_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.8576 211.306C38.9535 211.306 42.2711 207.985 42.2711 203.884C42.2711 197.735 47.2493 192.751 53.3914 192.751L53.3914 196.462C49.2954 196.462 45.9779 199.784 45.9779 203.884C45.9779 210.033 40.9997 215.017 34.8576 215.017C30.7616 215.017 27.444 218.339 27.444 222.439C27.444 228.588 22.4659 233.572 16.3238 233.572C12.2278 233.572 8.91023 236.894 8.91023 240.994L5.20347 240.994C5.20347 234.845 10.1817 229.861 16.3238 229.861C20.4197 229.861 23.7373 226.54 23.7373 222.439C23.7373 216.29 28.7155 211.306 34.8576 211.306ZM38.4717 258.555L22.7439 274.3L20.1232 271.677L35.851 255.931L38.4717 258.555Z"
				></path>
			</g>
			<g filter="url(#filter39_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.8576 307.682C38.9535 307.682 42.2711 304.361 42.2711 300.26C42.2711 294.111 47.2493 289.127 53.3914 289.127L53.3914 292.838C49.2954 292.838 45.9779 296.16 45.9778 300.26C45.9778 306.409 40.9997 311.393 34.8576 311.393C30.7616 311.393 27.444 314.715 27.444 318.815C27.444 324.964 22.4659 329.948 16.3238 329.948C12.2278 329.948 8.91023 333.27 8.91023 337.37L5.20346 337.37C5.20346 331.221 10.1816 326.237 16.3238 326.237C20.4197 326.237 23.7373 322.916 23.7373 318.815C23.7373 312.666 28.7155 307.682 34.8576 307.682ZM38.4717 354.931L22.7439 370.676L20.1232 368.053L35.851 352.307L38.4717 354.931Z"
				></path>
			</g>
			<g filter="url(#filter40_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.8576 404.058C38.9535 404.058 42.2711 400.737 42.2711 396.636C42.2711 390.487 47.2493 385.503 53.3914 385.503L53.3914 389.214C49.2954 389.214 45.9778 392.535 45.9778 396.636C45.9778 402.785 40.9997 407.769 34.8576 407.769C30.7616 407.769 27.444 411.09 27.444 415.191C27.444 421.34 22.4659 426.324 16.3237 426.324C12.2278 426.324 8.91022 429.645 8.91022 433.746L5.20346 433.746C5.20346 427.597 10.1816 422.613 16.3237 422.613C20.4197 422.613 23.7373 419.292 23.7373 415.191C23.7373 409.042 28.7155 404.058 34.8576 404.058ZM38.4717 451.306L22.7439 467.052L20.1232 464.428L35.851 448.683L38.4717 451.306Z"
				></path>
			</g>
			<g filter="url(#filter41_d_1_608)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.8576 500.434C38.9535 500.434 42.2711 497.113 42.2711 493.012C42.2711 486.863 47.2493 481.879 53.3914 481.879L53.3914 485.59C49.2954 485.59 45.9778 488.911 45.9778 493.012C45.9778 499.161 40.9997 504.145 34.8576 504.145C30.7616 504.145 27.444 507.466 27.444 511.567C27.444 517.716 22.4658 522.7 16.3237 522.7C12.2278 522.7 8.91022 526.021 8.91022 530.122L5.20346 530.122C5.20346 523.973 10.1816 518.989 16.3237 518.989C20.4197 518.989 23.7373 515.668 23.7373 511.567C23.7373 505.418 28.7155 500.434 34.8576 500.434ZM38.4716 547.682L22.7439 563.428L20.1232 560.804L35.851 545.059L38.4716 547.682Z"
				></path>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_d_1_608"
				x="338.812"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter1_d_1_608"
				x="338.812"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter2_d_1_608"
				x="338.812"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter3_d_1_608"
				x="338.812"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter4_d_1_608"
				x="338.812"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter5_d_1_608"
				x="338.812"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter6_d_1_608"
				x="283.211"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter7_d_1_608"
				x="283.211"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter8_d_1_608"
				x="283.211"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter9_d_1_608"
				x="283.211"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter10_d_1_608"
				x="283.211"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter11_d_1_608"
				x="283.211"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter12_d_1_608"
				x="227.609"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter13_d_1_608"
				x="227.609"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter14_d_1_608"
				x="227.609"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter15_d_1_608"
				x="227.609"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter16_d_1_608"
				x="227.609"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter17_d_1_608"
				x="227.609"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter18_d_1_608"
				x="172.008"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter19_d_1_608"
				x="172.008"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter20_d_1_608"
				x="172.008"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter21_d_1_608"
				x="172.008"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter22_d_1_608"
				x="172.008"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter23_d_1_608"
				x="172.008"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter24_d_1_608"
				x="116.406"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter25_d_1_608"
				x="116.406"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter26_d_1_608"
				x="116.406"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter27_d_1_608"
				x="116.406"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter28_d_1_608"
				x="116.406"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter29_d_1_608"
				x="116.406"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter30_d_1_608"
				x="60.8049"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter31_d_1_608"
				x="60.8049"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter32_d_1_608"
				x="60.8049"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter33_d_1_608"
				x="60.8049"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter34_d_1_608"
				x="60.8049"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter35_d_1_608"
				x="60.8049"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter36_d_1_608"
				x="5.20348"
				y="0"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter37_d_1_608"
				x="5.20348"
				y="96.376"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter38_d_1_608"
				x="5.20347"
				y="192.751"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter39_d_1_608"
				x="5.20346"
				y="289.127"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter40_d_1_608"
				x="5.20346"
				y="385.503"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<filter
				id="filter41_d_1_608"
				x="5.20345"
				y="481.879"
				width="48.1879"
				height="88.5488"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				></feColorMatrix>
				<feOffset dy="7"></feOffset>
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
				></feColorMatrix>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1_608"
				></feBlend>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_1_608"
					result="shape"
				></feBlend>
			</filter>
			<clipPath id="clip0_1_608">
				<rect
					width="530"
					height="387"
					fill="white"
					transform="translate(387) rotate(90)"
				></rect>
			</clipPath>
		</defs>
	</svg>
</div>
